import en from './en.js';
import de from './de.js';
import pt from './pt.js';
import it from './it.js';

const langs = {
  en,
  de,
  pt,
  it,
};

export default langs;
